import {
  Box,
  Button,
  Divider,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  FormControlLabel,
  MenuItem,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useToast } from 'use-toast-mui';
import AnimationPage from '../../pages/AnimationPage';
import { errorMessages } from '../../utils/methods';
import CustomCheckbox from '../CustomCheckbox';
import CustomRadioBox from '../CustomRadioBox';
import { FormInputDropdown } from '../form/FormInputDropdown';
import { useForm } from 'react-hook-form';
import { getAllBanners, deleteBannerById } from '../../api/ticket';
import { FormInputText } from '../../form-components/FormInputText';
import BannerDeleteModal from './BannerDeleteModal';

const positionType = [
  {
    label: 'MAIN_01',
    value: 'MAIN_01',
  },
  {
    label: 'MAIN_02',
    value: 'MAIN_02',
  },
  {
    label: 'MAIN_03',
    value: 'MAIN_03',
  },
];

var qs = require('qs');

const ListBanner = () => {
  const { t } = useTranslation();
  const token = useSelector(function (state) {
    return state.user.user.token;
  });
  const initialQuery = {
    page: 1,
    limit: 10,
    title: '',
    status: 'POSTING',
    position: '',
  };

  const toast = useToast();
  const [list, setList] = useState([]);
  const [query, setQuery] = useState(initialQuery);
  const [statusType, setStatusType] = useState(true);
  const [ids, setIds] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [open, setOpen] = useState(false);
  const { handleSubmit, control, reset, watch, getValues, setValue } = useForm({ defaultValues: initialQuery });

  const getList = async () => {
    const queryString = qs.stringify(query);
    try {
      const data = await getAllBanners(queryString, token);
      setList(data);
    } catch (error) {
      console.error('API call failed:', error);
      toast.error(errorMessages(error));
    }
  };

  const handleStatusType = type => {
    setStatusType(type);
    setQuery(prevValues => {
      return { ...prevValues, status: type ? 'POSTING' : 'HIDDEN' };
    });
  };

  const handleChange = id => {
    setIds(prevIds => {
      // Check if the id already exists in the array
      if (prevIds.includes(id)) {
        // If it exists, remove it (filter it out)
        return prevIds.filter(existingId => existingId !== id);
      } else {
        // If it doesn't exist, add it to the array
        return [...prevIds, id];
      }
    });
  };

  const handleAllSelect = () => {
    setCheckAll(!checkAll);

    if (!checkAll) {
      // Select all items
      setIds(list?.content?.map(el => el.bannerId));
    } else {
      // Deselect all items
      setIds([]);
    }
  };

  const handleChangePage = (_, value) => {
    setQuery({ ...query, page: value });
  };

  const handleDeleteList = async () => {
    if (!ids.length) return;

    try {
      const deletePromises = ids.map(id => deleteBannerById(id, token));
      await Promise.all(deletePromises);

      toast.success(t('Banner(s) Deleted'));

      getList();
      setIds([]);
    } catch (err) {
      console.log(err);
      toast.error(errorMessages(err));
    }
  };

  useEffect(() => {
    setQuery(prevValues => {
      return { ...prevValues, position: getValues('position') };
    });
  }, [watch('position')]);

  useEffect(() => {
    getList();
  }, [query]);
  return (
    <AnimationPage>
      <Box
        component={Paper}
        elavation={2}
        sx={{
          background: '#fff',
          borderRadius: '10px',
          padding: '30px 40px',
          width: '1080px',
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, minWidth: '50px' }}>
              {t('Search')}
            </Typography>

            <FormInputText
              color="info"
              sx={{ width: '375px' }}
              size="small"
              placeholder="내용을 입력해주세요"
              id="outlined-search"
              type="search"
              name="title"
              control={control}
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  setQuery(prevValues => {
                    return { ...prevValues, title: getValues('title') };
                  });
                }
              }}
            />
            <Button
              onClick={() => {
                setQuery(prevValues => {
                  return { ...prevValues, title: getValues('title') };
                });
              }}
              sx={{
                ml: '4px',
                background: '#0F7F85',
                border: '1px solid #0F7F85',
                color: 'white',
                width: '62px',
                height: '39px',
                '&:hover': {
                  color: '#0F7F85',
                  background: 'none',
                },
              }}
              variant="text">
              {t('Search')}
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, minWidth: '50px' }}>
            {t('Display status')}
          </Typography>
          <FormControlLabel
            sx={{ fontWeight: 400 }}
            control={<CustomRadioBox checked={statusType === true} onChange={() => handleStatusType(true)} />}
            label={t('Post')}
          />
          <FormControlLabel
            sx={{ ml: 1, fontWeight: 400 }}
            control={<CustomRadioBox checked={statusType === false} onChange={() => handleStatusType(false)} />}
            label={t('Hidden')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, minWidth: '50px' }}>
            {t('Display location')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem value={''}>{t('전체')}</MenuItem>}
            name="position"
            rules={{ required: false }}
            control={control}
            options={positionType}
            // onChange={handleChange}
            // value={ticketData?.sportType}
            sx={{ width: '114px', mr: 2 }}
          />
        </Box>
        <Divider sx={{ mb: '20px', mt: '26px', color: '#e1e1e1' }} />
        <TableContainer className="table" sx={{ mt: '10px', borderRadius: '5px' }}>
          <Table size="small" aria-label="a dense table">
            <TableHead
              sx={{
                '& .MuiTableRow-root th:first-child': {
                  borderTopLeftRadius: '10px',
                  borderBottomLeftRadius: '10px',
                },
                '& .MuiTableRow-root th:last-child': {
                  borderTopRightRadius: '10px',
                  borderBottomRightRadius: '10px',
                },
                background: '#ECECEC',
              }}>
              <TableRow>
                <TableCell align="center">
                  <CustomCheckbox color="primary" onChange={handleAllSelect} checked={checkAll} />
                </TableCell>
                <TableCell align="center">{t('ID')}</TableCell>
                <TableCell align="center">{t('Display')}</TableCell>
                <TableCell align="center">{t('Position')}</TableCell>
                <TableCell align="center">{t('Location')}</TableCell>
                <TableCell align="center">{t('Title')}</TableCell>
                <TableCell align="center">{t('Published Date')}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.content?.map((row, index) => (
                <TableRow
                  component={Link}
                  to={`/banner/${row?.bannerId}`}
                  // role="checkbox"
                  key={index}
                  sx={{
                    textDecoration: 'none',
                    // "&:hover": { background: "#ddd" },
                    '&:last-child td, &:last-child th': { borderBottom: 0 },
                  }}>
                  <TableCell align="center" padding="checkbox">
                    <CustomCheckbox
                      color="primary"
                      name="selectedBanners"
                      checked={ids.includes(row?.bannerId)}
                      onClick={e => e.stopPropagation()}
                      onChange={() => handleChange(row?.bannerId)}
                    />
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {row?.bannerId}
                  </TableCell>
                  <TableCell align="center">{t(row?.status)}</TableCell>
                  <TableCell align="center">{t(row?.position)}</TableCell>
                  <TableCell align="center">{t(row?.landingType)}</TableCell>
                  <TableCell align="center">{row?.title}</TableCell>
                  <TableCell align="center">{row?.registeredDate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <BannerDeleteModal open={open} setOpen={setOpen} handleDelete={handleDeleteList} />
        <Box
          sx={{
            display: 'flex',
            mt: '10px',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}>
          <Button
            onClick={() => setOpen(true)}
            sx={{
              p: '12px 37px 11px 37px',
              borderRadius: '5px',
              height: '36px',
              width: '100px',
              background: '#98A6AD',
              color: '#fff',
              '&:hover': { background: '#ddd' },
            }}>
            {t('Delete')}
          </Button>
          <Stack spacing={1}>
            <Pagination
              count={Math.ceil(list?.totalElements / query.limit) || 0}
              onChange={handleChangePage}
              page={query.page}
              color="primary"
              variant="outlined"
              shape="rounded"
              sx={{
                '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium': {
                  background: '#0F7F85',
                  border: 'none',
                  height: '24px',
                  minWidth: '24px',
                },
                '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium.Mui-selected': {
                  background: '#0F7F85',
                  color: '#fff',
                },
                '.MuiPaginationItem-icon': {
                  color: '#fff',
                },
              }}
            />
          </Stack>
          <Link to="/banner/create">
            <Button
              sx={{
                p: '12px 56px 11px 55px',
                borderRadius: '5px',
                height: '36px',
                width: '137px',
                background: '#0F7F85',
                color: '#fff',
                '&:hover': { background: '#0F7F85', color: '#fff' },
              }}>
              {t('Create')}
            </Button>
          </Link>
        </Box>
      </Box>
    </AnimationPage>
  );
};

export default ListBanner;
